<template>
  <div class="wrapper">
    <AppLogo variant="prelogin"/>
    <OTPLoginVerifyForm/>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import OTPLoginVerifyForm from "../../components/Authentication/Login/OTPLoginVerifyForm.vue";
import AppLogo from "../../components/Widgets/AppLogo.vue";

export default defineComponent({
  name: "OTPLoginVerivyPage",
  components: {
    AppLogo,
    OTPLoginVerifyForm
  },
});
</script>
